import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { BehaviorSubject } from "rxjs";
import { JsonApiService } from "@app/core/services/json-api.service";
import { map } from 'rxjs/operators';
import { Config } from "@app/config/config";

const config = new Config();

@Injectable()
export class CountryService {
    readonly rootUrl = config.webAPIUrl;

    constructor(private jsonApiService: JsonApiService, private http: HttpClient) {
    }
  
     getCountries() {
         return this.http.get(this.rootUrl+"/api/Country/List");
     }
  }
  